export const routePath = {
    WorkFlow: 'WorkFlow',
    Dashboard: 'Dashboard',
    pendingApproval: "Pending Approval",
    fileMasterData: "File Master Data",
    duplicate: "Duplicate",
    sapXMLPayload: "sapXMLPayload",
    initiateDocument: "Creator Documents",
    paymentInitiateDocument: "Initiate Payment",
    Approvals: 'Approvals',
    Exception: 'Exception',
    Reports: 'Reports',
    curbayTable: 'Curebay Table',
    Onboarding: 'Onboarding',
    Approved: 'Approved',
    Rejected: 'Rejected',
    addWord: 'Add Word',
    Users: 'Users',
    Permissions: 'Permissions',
    Form: 'Form',
    FormBuilder: "Form Builder",
    TaxCodes: "Tax Codes",
    WthTaxs: "WTH Tax Codes",
    FastForwardingVendorMaster: "Fast Forwarding Vendor Master",
    CrmGlCode: "CRM GL Code Master",
    CostCenter: 'Cost Center',
    ForeignBankMaster: 'Foreign Bank Master',
    foreignDocumentUpload: 'Document Upload',
    foreignAdminTools: 'Foreign Admin Tools',
    emergingRegion: 'Emerging Region',
    PrFiUserMapping: 'PR FI User Mapping',
    miroDocuments: 'Miro Documents',
    extractor: 'Data Extractor',
    vendorSaaDetails: 'Vendor & SAA Details',
    poMiroUser: 'PO Miro User',
    VendorPaymentTerm: 'Vendor Payment Term',
}